import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { NgbModal, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { FilteringService } from 'src/app/services/filtering.service';
import { SupportIssue, SupportIssueFilter, SupportIssueStatus, SupportIssueType } from '../models/SupportIssue';
import { NotesDialogComponent } from '../notes-dialog/notes-dialog.component';
import { SupportIssueService } from '../services/support-issue.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { UserAudit } from 'src/app/users-module/models/userLight';
import { UserService } from 'src/app/users-module/services/user.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-issue-list',
  templateUrl: './issue-list.component.html',
  styleUrls: ['./issue-list.component.less']
})
export class IssueListComponent implements OnInit, OnDestroy, AfterViewInit {
  public sub1 : Subscription;
  // @ViewChild('t', {}) ngbTabset: NgbTabset;
  filter: SupportIssueFilter;
  processors: UserAudit[] = [];
  def: NgbNav;
  constructor(public issues: SupportIssueService, public modalService: NgbModal, public filtering: FilteringService, private toast: ToastrService, 
    public router: Router, public usrs: UserService, public auth: AuthService) { }
  ngAfterViewInit(): void {

  }
  ngOnDestroy(): void {
    if(this.sub1) this.sub1.unsubscribe();
  }

  ngOnInit() {
    this.sub1 = this.issues.issueTypesLoaded.subscribe((ev: SupportIssueType[])=>{
      var filt = new SupportIssueFilter();    
      this.issues.fetchFilteredSupportIssues(filt, !this.auth.UserInRole('manager'));
    })
    this.issues.fetchSupportIssueTypes();
    this.activeTab = 2;
    this.filter = new SupportIssueFilter();
    //RIQ-4822: as of this ticket, we only really care about QA defects, so hard coding for now.
    this.issues.fetchDefects(13);
    this.usrs.FetchUsersForAuditReport().pipe(
      tap((_:UserAudit[]) => {
        this.processors = _;
      },
      err => {
            this.toast.error('', 'Error', { closeButton: true, disableTimeOut: true });
          },
          () => {
          })
        ).subscribe();

  }

  public showActive: boolean = true;
  public activeTab: number;

  openNotesDialog(issue: SupportIssue): void {
    let modalRef = this.modalService.open(NotesDialogComponent, { centered: true, size: 'xl' });
    modalRef.componentInstance.name = "NotesDialog";
    modalRef.componentInstance.issue = issue;
  }

  reopenIssue(issue: SupportIssue): void {
    issue.status = SupportIssueStatus.Open;
    this.issues.updateSupportIssue(issue).subscribe(res => {
      //this.ngbTabset.select('openissues');
      this.openNotesDialog(issue);
    },
    err => {
      this.toast.error('Error reopening issue.', '', { closeButton: true, disableTimeOut: true })
    },
    () => this.toast.success('Issue reopened!', ''))
  }

  onNavChange(event:any): void {
    console.log('nav change event: ', event);
    this.activeTab = event.nextId;
    if(event.nextId == 2) 
    {
      var filt = new SupportIssueFilter();
      // filt.status = 10;
      this.issues.fetchFilteredSupportIssues(filt, !this.auth.UserInRole('manager'));
    }
  }

  openScreeningEditView(issue: SupportIssue): void {
    //this.router.navigateByUrl(`/screenings/review/${issue.screeningId}`);
    window.open(environment.portal + `/screenings/review/${issue.screeningId}`);
  }

  public get orderedIssues(): SupportIssue[] {
    if(!this.issues.supportIssues)
      return [];
    else {
      return this.issues.supportIssues.filter(rec => { return rec.status < 30 });
    }
  }

  public get qaIssues(): SupportIssue[] 
  {
    if(!this.issues.supportIssues)
      return [];
    else {
      return this.issues.supportIssues.filter(rec => { return rec.issueType && (rec.issueType.issueName == "QA Finding" || rec.issueType.issueName == "Review Income") && rec.status < 30; });
    }
  }
  


  public get resolvedIssues(): SupportIssue[] {
    if(!this.issues.supportIssues)
      return [];
    else {
      return this.issues.supportIssues.filter(rec => { return rec.status >= 30 });
    }
  }

  applyFilters(): void {
    this.issues.fetchFilteredSupportIssues(this.filter, !this.auth.UserInRole('manager'));
  }

  clearFilters(): void {
    this.filter = new SupportIssueFilter();
    this.issues.fetchFilteredSupportIssues(this.filter, !this.auth.UserInRole('manager'));
  }

}
